import React from "react";

import { useMainStore } from "@/contexts/Store";

import { getWorkspaceLogo } from "./getWorkspaceLogo";

export const renderWorkspaces = (workspaceID: number) => {
  // Import MobX stores
  const mainStore = useMainStore();

  return mainStore.workspaces.list
    .filter((workspace) => workspace.id === workspaceID)
    .map((workspace) => {
      const { logo, isInternal } = getWorkspaceLogo(workspace);

      return (
        <div key={workspace.id} className="task-modules-block">
          <img src={logo} alt="logo-icon" />
          {isInternal ? workspace.company.name : workspace.name}
        </div>
      );
    });
};
